<template>
  <div>
    <el-card class="mb15" shadow="hover">
      <el-row>
        <el-input
          :placeholder="$t('search')"
          clearable
          v-model="filter.search"
          @keyup.enter.native="get_list"
        ></el-input>
      </el-row>
      <!-- <el-row class="mt20" type="flex" :gutter="20" align="middle">
          <span class="text">{{$t('serialList.day_of_week')}}:</span>
           <el-checkbox-group v-model="day_arr" @change="handleChange">
            <el-checkbox label="0">{{day_of_week('0')}}</el-checkbox>
            <el-checkbox label="1">{{day_of_week('1')}}</el-checkbox>
            <el-checkbox label="2">{{day_of_week('2')}}</el-checkbox>
            <el-checkbox label="3">{{day_of_week('3')}}</el-checkbox>
            <el-checkbox label="4">{{day_of_week('4')}}</el-checkbox>
          </el-checkbox-group>
      </el-row>
       <el-row class="mt20 flex" type="flex" :gutter="20" align="middle">
          <span class="text">{{$t('serialList.is_switch_on')}}:</span>
          <el-radio-group size="medium" v-model="filter.is_switch_on">
               <el-radio label>{{$t('serialList.all')}}</el-radio>
              <el-radio :label="0">{{is_switch_on(0)}}</el-radio>
              <el-radio :label="1">{{is_switch_on(1)}}</el-radio>
          </el-radio-group>
      </el-row>
       <el-row class="mt20 flex" type="flex" :gutter="20" align="middle">
          <span class="text">{{$t('serialList.status')}}:</span>
         <el-radio-group size="medium" v-model="filter.status">
              <el-radio label>{{$t('serialList.all')}}</el-radio>
              <el-radio label="0">{{status(0)}}</el-radio>
              <el-radio label="1">{{status(1)}}</el-radio>
          </el-radio-group>
      </el-row> -->
      <el-row class="mt20 flex" type="flex" :gutter="20" align="middle">
        <span class="text">{{ $t('serialList.active') }}:</span>
        <el-radio-group size="medium" v-model="filter.active">
          <el-radio label>{{ $t('serialList.all') }}</el-radio>
          <el-radio label="0">{{ active(0) }}</el-radio>
          <el-radio label="1">{{ active(1) }}</el-radio>
        </el-radio-group>
      </el-row>
      <el-row class="mt20" type="flex" align="middle">
        <el-button @click="get_list" type="primary" class="search">{{
          $t('search_zh')
        }}</el-button>
        <el-button @click="reset" type="info">{{
          $t('btnTip.reset')
        }}</el-button>
      </el-row>
    </el-card>
    <el-card shadow="hover">
      <div class="flexBC mb20">
        <el-button type="primary" @click="handleClick('add')">{{
          $t('btnTip.add')
        }}</el-button>
        <el-button type="primary" @click="outExe">{{ $t('outExe') }}</el-button>
      </div>
      <my-table
        :columns="columns"
        :data="list_data.list"
        :showIndex="false"
        :showSelection="false"
        :cellStyle="{ padding: '6px 0' }"
        :headerCellStyle="{
          background: 'rgba(51, 55, 68, 1)',
          color: '#fff',
        }"
        @emitSelection="allSelect"
        @sortChange="sort_change"
      >
        <!-- <template v-slot:title="slotProps">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('serialList.toChapterList')"
            placement="top"
          >
            <div
              class="under_line"
              @click="handleClick('chapterList', slotProps.callback.row)"
            >
              {{ slotProps.callback.row.title }}
            </div>
          </el-tooltip>
        </template> -->
        <!-- <template v-slot:day_of_week="slotProps">
          <div>
            <span
              class="span"
              v-for="(item, index) in slotProps.callback.row.day_of_week"
              :key="index"
              >{{ day_of_week(item) }}</span
            >
          </div>
        </template> -->
        <!-- <template v-slot:status="slotProps">
          <el-tag :type="statusTag(slotProps.callback.row.status)">
            {{ status(slotProps.callback.row.status) }}
          </el-tag>
        </template> -->
        <template v-slot:active="slotProps">
          <el-tag :type="activeTag(slotProps.callback.row.active)">
            {{ active(slotProps.callback.row.active) }}
          </el-tag>
        </template>
        <!-- <template v-slot:is_switch_on="slotProps">
          <el-tag :type="is_switch_onTag(slotProps.callback.row.is_switch_on)">
            {{ is_switch_on(slotProps.callback.row.is_switch_on) }}
          </el-tag>
        </template> -->
        <template v-slot:operation="slotProps">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').check"
            placement="top"
          >
            <el-button
              @click="handleClick('check', slotProps.callback.row)"
              icon="el-icon-view"
              type="success"
              size="mini"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').edit"
            placement="top"
          >
            <el-button
              @click="handleClick('edit', slotProps.callback.row)"
              icon="el-icon-edit-outline"
              type="primary"
              size="mini"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').delete"
            placement="top"
          >
            <el-button
              size="mini"
              type="danger"
              @click="del(slotProps.callback.row.id)"
              >{{ $t('btnTip').delete }}</el-button
            >
          </el-tooltip>
        </template>
      </my-table>
      <page
        :total="list_data.total"
        :page_size.sync="pageSize"
        :page.sync="page"
      />
    </el-card>
  </div>
</template>
<script>
import { mixin_list } from '@/mixins';
import page from '@/components/page';
import myTable from '@/components/table';
import { serialList, deleteSerial } from '@/api/api';
export default {
  name: 'serialList',
  mixins: [mixin_list(serialList)],
  components: {
    myTable,
    page,
  },
  data() {
    return {
      filter: {
        search: '',
        day_of_week: '',
        status: '',
        active: '',
        is_switch_on: '',
      },
      day_arr: [],
      columns: [
        {
          label: 'ID',
          sortable: true,
          prop: 'id',
          width: 80,
        },
        {
          label: this.$t('serialList.update_time'),
          sortable: true,
          prop: 'update_time',
        },
        {
          label: this.$t('serialList.title'),
          sortable: true,
          prop: 'title',
        },
        {
          label: this.$t('serialList.author_name'),
          sortable: true,
          prop: 'author_name',
        },
        // {
        //   label: this.$t('serialList.day_of_week'),
        //   prop: 'day_of_week',
        //   slot: 'day_of_week',
        // },
        {
          label: this.$t('serialList.chapter_name'),
          sortable: true,
          prop: 'chapter_name',
        },
        {
          label: this.$t('serialList.like_num'),
          sortable: true,
          prop: 'like_num',
        },
        // {
        //   label: this.$t('serialList.status'),
        //   sortable: true,
        //   prop: 'status',
        //   slot: 'status',
        // },
        {
          label: this.$t('serialList.active'),
          sortable: true,
          prop: 'active',
          slot: 'active',
        },
        // {
        //   label: this.$t('serialList.is_switch_on'),
        //   sortable: true,
        //   prop: 'is_switch_on',
        //   slot: 'is_switch_on',
        // },
        {
          label: this.$t('operation'),
          prop: '',
          width: 300,
          slot: 'operation',
        },
      ],
    };
  },
  methods: {
    handleChange(value) {
      this.filter.day_of_week = value.join(',');
    },
    is_switch_onTag(is_switch_on) {
      switch (is_switch_on) {
        case 0:
          return 'info';
        case 1:
          return 'success';
      }
    },
    is_switch_on(is_switch_on) {
      switch (is_switch_on) {
        case 0:
          return this.$t('serialList.switch_on0');
        case 1:
          return this.$t('serialList.switch_on1');
      }
    },
    day_of_week(day_of_week) {
      switch (day_of_week) {
        case '0':
          return this.$t('day1');
        case '1':
          return this.$t('day2');
        case '2':
          return this.$t('day3');
        case '3':
          return this.$t('day4');
        case '4':
          return this.$t('day5');
      }
    },
    status(status) {
      switch (status) {
        case 0:
          return this.$t('serialList.status0');
        case 1:
          return this.$t('serialList.status1');
      }
    },
    statusTag(statusTag) {
      switch (statusTag) {
        case 0:
          return 'success';
        case 1:
          return 'info';
      }
    },
    active(active) {
      switch (active) {
        case 0:
          return this.$t('serialList.active0');
        case 1:
          return this.$t('serialList.active1');
      }
    },
    activeTag(activeTag) {
      switch (activeTag) {
        case 0:
          return 'warning';
        case 1:
          return 'success';
      }
    },
    async handleClick(type, data) {
      switch (type) {
        case 'add':
          this.$router.push('/serialManagement/edit');
          break;
        case 'edit':
          this.$router.push(`/serialManagement/edit?id=${data.id}`);
          break;
        case 'check':
          this.$router.push(`/serialManagement/detail?id=${data.id}`);
          break;
        case 'chapterList':
          this.$router.push(
            `/serialManagement/serialList/chapterList?id=${data.id}`
          );
          break;
      }
    },
    async del(id) {
      this.$confirm(this.$t('serialList').sureDeleteSerial, this.$t('tips'), {
        confirmButtonText: this.$t('btnTips').submit,
        cancelButtonText: this.$t('btnTips').cancel,
        type: 'warning',
      })
        .then(async () => {
          let res = await deleteSerial(id);
          this.get_list();
        })
        .catch({});
    },
  },
};
</script>
<style lang="scss" scoped>
.span + .span::before {
  content: '/';
}
.text {
  width: 120px;
  font-size: 16px;
}
/deep/ label {
  margin-bottom: 0 !important;
}
</style>
